import * as React from "react";
import ViewSummary from "./View-summary";
import TimeTableJoinNow from "./Time-table-join-now";
import TimeTableEvents from "./Time-table-events";
import Upcoming from "./Upcoming";
import { Tooltip } from "@mui/material";
import { useEffect } from "react";
import LiveTvIcon from "@mui/icons-material/LiveTv";

const TimeTableDayEvent = ({
  event,
  refetch,
  SDate,
  EDate,
  refresh,
  setIsCreateLinkClicked,
}) => {
  const currentTime = new Date();
  const eventStartTime = new Date(event?.StartTime);
  const eventEndTime = new Date(event?.EndTime);

  const hasLiveLecture = (event) => {
    return event.Events?.some((e) => e.name === "bbb_lecture") || false;
  };


  const isHappened = currentTime.getTime() > eventEndTime.getTime();
  const isEventHappening =
    currentTime.getTime() >= eventStartTime.getTime() &&
    currentTime.getTime() <= eventEndTime.getTime();
  const isUpcoming =
    currentTime.getTime() < eventStartTime.getTime() && !isEventHappening;

  const onJoinNowClick = (e) => {
    e.preventDefault();
    //allow to display pop onClick
    // e.stopPropagation();
  };

  function shortenParagraph(text, maxLength) {
    if (text?.length <= maxLength) {
      return text;
    }
    return text?.slice(0, maxLength).trim() + "...";
  }

  const teacherName =
    event?.TeacherName === undefined ? "" : event?.TeacherName;
  return event ? (
    <div onClick={onJoinNowClick} className="py-2 border rounded mb-2">
      {event.LactureType === "general_lacture" &&
        event.Events[0] !== "Planner" && (
          <div
            className="weekStyleDay"
            style={{ marginLeft: "20px", letterSpacing: "1.2em" }}
          >
            {event.LectureName.toUpperCase()}
          </div>
        )}
      <div className="row align-items-center p-2">
        {/* Lecture Type / Name - 2 columns */}
        <div className="col-2">
          {event.LactureType !== "general_lacture" &&
            !event.bbb_lecture_id &&
            event.Events[0] !== "Planner" && (
              <span className="" style={{ fontSize: "14px", fontWeight: 400 }}>
                🏫 Classroom
              </span>
            )}
          {event.LactureType !== "general_lacture" &&
            event.bbb_lecture_id &&
            event.Events[0] !== "Planner" && (
              <span className="" style={{ fontSize: "14px", fontWeight: 400 }}>
                💻 Online Classes
              </span>
            )}
        </div>

        {/* Subject - 3 columns */}
        {event.Events[0] !== "Planner" &&
          event.LactureType !== "general_lacture" && (
            <div className="col-2">
              <Tooltip title={event.Subject} arrow placement="bottom">
                <span
                  className="text-truncate fw-semibold d-block"
                  style={{ fontSize: "14px" }}
                >
                  {shortenParagraph(event?.Subject, 20)}
                </span>
              </Tooltip>
            </div>
          )}

        {/* Teacher - 2 columns */}
        {event.Events[0] !== "Planner" &&
          event.LactureType !== "general_lacture" && (
            <div className="col-2">
              <Tooltip title={teacherName} arrow placement="bottom">
                <span
                  className="small text-truncate fw-semibold d-block"
                  style={{ fontSize: "14px" }}
                >
                  {shortenParagraph(teacherName, 15)}
                </span>
              </Tooltip>
            </div>
          )}

        {/* Events - 2 columns */}

        {/* Live Icon + Join Now - 3 columns */}
        <div className="col-1 text-center">
          {hasLiveLecture(event) && isEventHappening && (
            <TimeTableJoinNow
              event={event}
              refetch1={refetch}
              SDate={SDate}
              EDate={EDate}
              setIsCreateLinkClicked={setIsCreateLinkClicked}
            />
          )}
        </div>

        <div className="col-1">
            {event.Events[0] !== "Planner" &&
            event.LactureType !== "general_lacture" && (
              <>
                {isEventHappening && <div>🟢 Live</div>}
                {!isEventHappening && !isHappened && <div>⏳ Upcoming</div>}
                {isHappened && <div>✅ Completed</div>}
              </>
            )}
        </div>

        {/* Upcoming (only if not live) - 3 columns */}
        <div className="col-1">
          {!isHappened && event.Events[0] !== "Planner" &&
            event.LactureType !== "general_lacture" && (
          <div className="col-auto">
            <Upcoming
              setIsCreateLinkClicked={setIsCreateLinkClicked}
              event={event}
              refetch1={refetch}
              SDate={SDate}
              EDate={EDate}
              hasLiveLecture={hasLiveLecture(event)}
            />
          </div>
        )}
        </div>
        
        {event.Events[0] !== "Planner" &&
          event.LactureType !== "general_lacture" && (
            <div className="col-2">
              <TimeTableEvents event={event} />
            </div>
          )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default TimeTableDayEvent;
